<div class="container-fluid text-left p-4 bg-header">
    <div>
      <img (click)="init()" [routerLink]="['/search']" src="./assets/images/logo_trad_arabes.png" class="mw-100 pointer" />
      <a href="http://www.fondation.org.ma" target="_blank">
        <img src="./assets/images/log_fondation.png" class="float-right show-min mw-100" />
      </a>
    </div>
    

</div>
<nav class="navbar navbar-expand-lg navbar-light bg-light py-1">
    <!--<a class="navbar-brand"  (click)="init()" [routerLink]="['/']" routerLinkActive="active" >{{ 'catalog' | translate }}</a>-->
    <form #f="ngForm" (ngSubmit)="onSearch(f.value)" class="form-inline w-100 my-2 my-lg-0">
      <input name="term" ngModel #term class="form-control form-control-sm col-12 col-md-4 m-2" type="term" placeholder="{{ 'term' | translate }}" aria-label="Terme">
      
     <!--  <select name="type" ngModel class="form-control form-control-sm col-8 col-md-2 m-2" [(ngModel)]="SelectedType">
        <option value="all" selected>{{ 'all' | translate }}</option>
        <option value="fromara">{{ 'fromara' | translate }}</option>
        <option value="toara">{{ 'toara' | translate }}</option>
      </select> -->
      <!-- <select name="type" ngModel class="form-control form-control-sm mr-sm-2" [(ngModel)]="SelectedType">
        <option value="expression">Mots/expression</option>
        <option value="title">Titre</option>
        <option value="isbn">ISBN</option>
        <option value="titleparallele">Titre parallèle</option>
        <option value="titleintermidiaire">Titre intermédiaire</option>
        <option value="titleoriginal">Titre original</option>
        <option value="author">Auteur</option>
        <option value="traducteur">Traducteur</option>
        <option value="reviseur">Réviseur</option>
        <option value="editeur">Editeur</option>
        <option value="anneeedition">Année d'édition</option>
        <option value="paysedition">Pays d'edition</option>
        <option value="nationaliteauteur">Nationalité d'auteur</option>
        <option value="matiere">Matière</option>
        <option value="planclassement">Plan classement</option>
        <option value="descript">Déscription</option>
        <option value="Langsource">Langue source</option>
        <option value="Langcible">Langue cible</option>
        <option value="paysorigine">Pays d'origine</option>
        <option value="statementres">Mentions de résponsabilité</option>
      </select> -->
      <input class="btn btn-sm btn-light my-2 my-sm-0" type="reset" value="X" (click)="reset()" ><br>
      <button class="btn btn-sm btn-success my-2 my-sm-0 mx-2" type="submit"  [routerLink]="['/search']">{{ 'recherche' | translate }}</button>
      
      <button type="button" [ngClass]="(SelectedType=='all')?'btn btn-sm btn-success my-2 my-sm-0':'btn btn-sm my-2 my-sm-0'" (click)="changetype('all')">
        {{ 'all' | translate }} <span class="badge badge-light"></span>
      </button>
      <button type="button" [ngClass]="(SelectedType=='fromara')?'btn btn-sm btn-success my-2 my-sm-0':'btn btn-sm my-2 my-sm-0'" (click)="changetype('fromara')">
        {{ 'fromara' | translate }} <span class="badge badge-light"></span>
      </button>
      <button type="button" [ngClass]="(SelectedType=='toara')?'btn btn-sm btn-success my-2 my-sm-0':'btn btn-sm my-2 my-sm-0'" (click)="changetype('toara')">
        {{ 'toara' | translate }} <span class="badge badge-light"></span>
      </button>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    </form>
  
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      
      
      <ul class="navbar-nav ml-auto">
        <li class="nav-item minwidth">
            <!-- <a class="nav-link dropdown-toggle" id="navbarsearch" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ 'recherche' | translate }}
            </a> -->
            <a class="nav-link pointer" id="navbarsearch" *ngIf="currentRoute == '/advanced'" [routerLink]="['/search']">
              {{ 'recherche_simple' | translate }}
            </a>
            <a class="nav-link pointer" id="navbarsearch" *ngIf="currentRoute == '/search'" [routerLink]="['/advanced']">
              {{ 'recherche_avance' | translate }}
            </a>
            <!-- <div class="dropdown-menu" aria-labelledby="navbarsearch">
              <a class="dropdown-item" (click)="init()" [routerLink]="['/search']" routerLinkActive="active">{{ 'recherche_simple' | translate }}</a>
              <a class="dropdown-item" (click)="term.value='';" [routerLink]="['/advanced']" routerLinkActive="active">{{ 'recherche_avance' | translate }}</a>
              <a class="dropdown-item" (click)="term.value='';" [routerLink]="['/statistic']" routerLinkActive="active">{{ 'statistc' | translate }}</a>
            </div> -->
        </li>
        <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarstat" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ 'statistic' | translate }}
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarstat">
              <a class="dropdown-item" [routerLink]="['/statistic']" routerLinkActive="active">{{ 'general' | translate }}</a>
              <a class="dropdown-item" [routerLink]="['/statpays']" routerLinkActive="active">{{ 'par_pays_edit' | translate }}</a>
            </div>
        </li>
        <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarpropos" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ 'aproposde' | translate }}
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarpropos">
              <a class="dropdown-item" [routerLink]="['/presentation']" routerLinkActive="active">{{ 'catalog' | translate }}</a>
              <a class="dropdown-item" href="http://www.fondation.org.ma" target="_blank">{{ 'Fondation' | translate }}</a>
            </div>
        </li>
        <!-- <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ 'about' | translate }}
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" [routerLink]="['/contact']" routerLinkActive="active">{{ 'contact' | translate }}</a>
                <div class="dropdown-divider"></div>
              <a class="dropdown-item" [routerLink]="['/aide']" routerLinkActive="active">{{ 'help' | translate }}</a>
            </div>
        </li> -->
        <li class="nav-item">
          <a class="nav-link pointer {{ 'dara' | translate }}" (click)="switchLang('fr')" routerLinkActive="active">{{ 'fr' | translate }}</a>
          <a class="nav-link pointer {{ 'dfre' | translate }}" (click)="switchLang('ar')" routerLinkActive="active">{{ 'ar' | translate }}</a>
      </li>
        <li class="nav-item">
          <a class="nav-link pointer refresh" (click)="rafraichir()">
           <img src="./assets/images/refresh.png" alt=""> {{ 'rafraichir' | translate }} 
          </a>
      </li>
      </ul>
    </div>
  </nav>
<br>

